import { NotificationItem } from "../models/notification.model";
import { ProfileOptionItem } from "../models/profileoption.model";
import { getCurrentLanguage } from 'src/app/core/helpers/utils';

const NOTIFICATIONS: NotificationItem[] = [
    /*
    {
        id: 1,
        isActive: true,
        text: 'Cristina Pride',
        subText: 'Hi, How are you? What about our next meeting',
        avatar: 'assets/images/users/user-1.jpg',
    },
    {
        id: 2,
        text: 'Caleb Flakelar commented on Admin',
        subText: '1 min ago',
        icon: 'mdi mdi-comment-account-outline',
        bgColor: 'primary',
    },
    {
        id: 3,
        text: 'Karen Robinson',
        subText: 'Wow ! this admin looks good and awesome design',
        avatar: 'assets/images/users/user-4.jpg',
    },
    {
        id: 4,
        text: 'New user registered.',
        subText: '5 hours ago',
        icon: 'mdi mdi-account-plus',
        bgColor: 'warning',
    },
    {
        id: 5,
        text: 'Caleb Flakelar commented on Admin',
        subText: '1 min ago',
        icon: 'mdi mdi-comment-account-outline',
        bgColor: 'info',
    },
    {
        id: 6,
        text: 'Carlos Crouch liked Admin',
        subText: '13 days ago',
        icon: 'mdi mdi-heart',
        bgColor: 'secondary',
    },
    */
];



const PROFILEOPTIONS_ES: ProfileOptionItem[] = [
    /*
    {
        label: 'Mi Perfil',
        icon: 'fe-user',
        redirectTo: '/arbitros/edit/1',
    },
    
    {
        label: 'Bloquear pantalla',
        icon: 'fe-lock',
        redirectTo: '/auth/lock-screen',
    },
    */
    {
        label: 'Cerrar sesión',
        icon: 'fe-log-out',
        redirectTo: '/auth/logout',
    }
];

const PROFILEOPTIONS_EN: ProfileOptionItem[] = [
    /*
    {
        label: 'Mi Perfil',
        icon: 'fe-user',
        redirectTo: '/arbitros/edit/1',
    },
    
    {
        label: 'Bloquear pantalla',
        icon: 'fe-lock',
        redirectTo: '/auth/lock-screen',
    },
    */
    {
        label: 'Log out',
        icon: 'fe-log-out',
        redirectTo: '/auth/logout',
    }
];

const currentLanguage = getCurrentLanguage(); // Asume que esta función devuelve 'en' o 'es'
const PROFILEOPTIONS = currentLanguage === 'en' ? PROFILEOPTIONS_EN : PROFILEOPTIONS_ES;

export { NOTIFICATIONS, PROFILEOPTIONS };